/* NutriGreen — motion + micro-interaction layer.
   Companion to nutrigreen-motion.css. Guarded against double-init,
   no-ops under prefers-reduced-motion (except the sticky ATC bar,
   which is a UX feature and simply skips its slide animation). */
(function () {
  if (window.__nutriMotionInit) return;
  window.__nutriMotionInit = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function cartIcon() {
    return document.getElementById('cart-icon-bubble');
  }

  /* ---------- cart count bubble pulse ---------- */
  function pulseBubble() {
    if (reduce) return;
    var icon = cartIcon();
    if (!icon) return;
    var bubble = icon.querySelector('.cart-count-bubble');
    if (!bubble) return;
    bubble.classList.remove('ng-pulse');
    void bubble.offsetWidth; // restart the animation
    bubble.classList.add('ng-pulse');
  }

  /* ---------- fly-to-cart ----------
     Remembers the last add-to-cart button pressed; when the cart
     updates shortly after, a thumbnail of the nearest product image
     arcs from the button to the cart icon, then the bubble pulses. */
  var lastAtcSource = null;
  var lastAtcAt = 0;
  document.addEventListener(
    'click',
    function (e) {
      if (!e.target || !e.target.closest) return;
      var btn = e.target.closest(
        'button[name="add"], .product-form__submit, .quick-add__submit, [data-add], [data-ng-sticky-submit]'
      );
      if (!btn) return;
      lastAtcSource = btn;
      lastAtcAt = Date.now();
    },
    true
  );

  function flyToCart(fromEl) {
    var icon = cartIcon();
    if (reduce || !fromEl || !icon || !fromEl.isConnected || typeof fromEl.animate !== 'function') {
      return pulseBubble();
    }
    var to = icon.getBoundingClientRect();
    if (!to.width) return pulseBubble();

    var scope = fromEl.closest('product-info, product-form, .nutri-builder, form, section') || document;
    var img = scope.querySelector('.product__media img, .nutri-ph__img, img');
    var from = (img && img.getBoundingClientRect().width ? img : fromEl).getBoundingClientRect();

    var dot = document.createElement('span');
    dot.className = 'ng-fly';
    if (img && img.currentSrc) {
      var thumb = document.createElement('img');
      thumb.src = img.currentSrc;
      thumb.alt = '';
      dot.appendChild(thumb);
    }
    var half = 22; // half the 44px dot
    var startX = from.left + from.width / 2 - half;
    var startY = from.top + from.height / 2 - half;
    dot.style.left = startX + 'px';
    dot.style.top = startY + 'px';
    document.body.appendChild(dot);

    var dx = to.left + to.width / 2 - half - startX;
    var dy = to.top + to.height / 2 - half - startY;
    var anim = dot.animate(
      [
        { transform: 'translate(0,0) scale(1)', opacity: 1 },
        { transform: 'translate(' + dx * 0.5 + 'px,' + (dy * 0.5 - 70) + 'px) scale(.7)', offset: 0.55 },
        { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.25)', opacity: 0.7 }
      ],
      { duration: 650, easing: 'cubic-bezier(.3,.6,.4,1)' }
    );
    anim.onfinish = anim.oncancel = function () {
      dot.remove();
      pulseBubble();
    };
  }

  var lastFx = 0;
  function onCartUpdate() {
    var now = Date.now();
    if (now - lastFx < 400) return; // pubsub + observer can both fire — run once
    lastFx = now;
    if (now - lastAtcAt < 4000 && lastAtcSource) {
      flyToCart(lastAtcSource);
      lastAtcSource = null;
    } else {
      pulseBubble();
    }
  }

  // Dawn forms publish cartUpdate; the box builder and apps re-render the
  // header bubble instead, so watch both.
  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, onCartUpdate);
  }
  function observeBubble() {
    var icon = cartIcon();
    if (!icon || !icon.parentNode || !('MutationObserver' in window)) return;
    new MutationObserver(onCartUpdate).observe(icon.parentNode, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  /* ---------- cart drawer: stagger rows on open only ---------- */
  function initDrawerStagger() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || reduce || !('MutationObserver' in window)) return;
    var wasOpen = drawer.classList.contains('active');
    new MutationObserver(function () {
      var open = drawer.classList.contains('active');
      if (open && !wasOpen) {
        drawer.classList.add('ng-stagger');
        setTimeout(function () {
          drawer.classList.remove('ng-stagger');
        }, 700);
      }
      wasOpen = open;
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  /* ---------- sticky add-to-cart bar (product pages) ----------
     Shows once the real buy button has scrolled above the viewport;
     its button proxies a click to the main product form's submit so
     variant/quantity logic stays in one place. */
  function initStickyAtc() {
    var bar = document.querySelector('.ng-sticky-atc');
    if (!bar) return;
    var form = document.querySelector('product-info form[data-type="add-to-cart-form"]');
    var watch = document.querySelector('product-info .product-form__buttons') || form;
    if (!form || !watch) return;

    bar.removeAttribute('hidden');
    // rAF-throttled scroll check (not IntersectionObserver: IO misses
    // instant jumps past the buy button, e.g. anchor links)
    var ticking = false;
    function update() {
      ticking = false;
      bar.classList.toggle('is-visible', watch.getBoundingClientRect().bottom < 0);
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();

    var proxy = bar.querySelector('[data-ng-sticky-submit]');
    if (proxy) {
      proxy.addEventListener('click', function () {
        var submit = form.querySelector('[type="submit"]');
        if (submit && !submit.disabled) {
          submit.click();
        } else {
          watch.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
        }
      });
    }
  }

  /* ---------- count-up stats ----------
     Animates the "N×" figures in the compare table's Nutri Green cells when
     they scroll into view. Server-rendered text is the final value, so no-JS
     and reduced-motion users simply see the finished number. The count runs
     while the cell is still fading in (cascade), which hides the restart.
     (Deliberately NOT applied to the hero stat: it's painted server-side
     before deferred JS runs, so a count-up there reads as a flash-and-restart,
     and pre-font-load width locks left a gap. The hero 40× stays static.) */
  function initCounters() {
    if (reduce || !window.requestAnimationFrame) return;

    // Find the first "N×" inside el and return its pieces for in-place updates.
    function findStat(el) {
      var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
      var node;
      while ((node = walker.nextNode())) {
        var m = node.nodeValue.match(/^([\s\S]*?)(\d+)(\s*×[\s\S]*)$/);
        if (m) return { node: node, pre: m[1], target: parseInt(m[2], 10), post: m[3] };
      }
      return null;
    }

    function count(stat, duration) {
      var from = Math.max(1, Math.round(stat.target * 0.04));
      var start;
      function step(ts) {
        if (start === undefined) start = ts;
        var p = Math.min(1, (ts - start) / duration);
        var eased = 1 - Math.pow(1 - p, 3);
        stat.node.nodeValue = stat.pre + Math.round(from + (stat.target - from) * eased) + stat.post;
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }

    // Count when the table scrolls into view, after the row cascade has
    // begun. The number sits at the end of its line, so the tiny width
    // change during the count can't push any other content around.
    var cells = [];
    document.querySelectorAll('.nutri-compare__cell.nutri-compare__us').forEach(function (el) {
      if (el.dataset.ngCount) return;
      var stat = findStat(el);
      if (!stat || stat.target < 2) return;
      el.dataset.ngCount = '1';
      cells.push(stat);
    });
    if (!cells.length || !('IntersectionObserver' in window)) return;
    var table = document.querySelector('.nutri-compare__table');
    if (!table) return;
    var io = new IntersectionObserver(function (entries) {
      if (!entries.some(function (e) { return e.isIntersecting; })) return;
      io.disconnect();
      setTimeout(function () {
        cells.forEach(function (stat) { count(stat, 900); });
      }, 400);
    }, { threshold: 0.3 });
    io.observe(table);
  }

  /* ---------- shared-element page transitions ----------
     The detail pages' hero images statically own the ng-shared-card
     view-transition-name (see nutrigreen-motion.css). Tagging the clicked
     card image with the same name right before navigation makes Chromium
     morph the card into the page; other browsers keep the root cross-fade. */
  var ngSharedHeroSel =
    '.nutri-recipe__hero-media .nutri-recipe__img, .nutri-recipe__hero-media .nutri-ph__ph, ' +
    '.nutri-variety__frame .nutri-ph__img, .nutri-variety__frame .nutri-ph__ph';
  function initSharedCards() {
    if (reduce || !document.startViewTransition) return;
    var marked = null;
    document.addEventListener(
      'click',
      function (e) {
        if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        if (!e.target || !e.target.closest) return;
        var card = e.target.closest('a.nutri-rail__card, a.nutri-rhub__card');
        if (!card) return;
        var media = card.querySelector('.nutri-ph__img, .nutri-ph__ph');
        if (!media) return;
        if (marked && marked !== media) marked.style.viewTransitionName = '';
        // a view-transition-name must be unique per page: when navigating
        // detail → detail (e.g. a related-recipe card), mute this page's hero
        // so the outgoing snapshot carries the name exactly once
        document.querySelectorAll(ngSharedHeroSel).forEach(function (el) {
          el.style.viewTransitionName = 'none';
        });
        media.style.viewTransitionName = 'ng-shared-card';
        marked = media;
      },
      true
    );
    // bfcache restore: untag everything so a later click can't duplicate names
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      if (marked) { marked.style.viewTransitionName = ''; marked = null; }
      document.querySelectorAll(ngSharedHeroSel).forEach(function (el) {
        el.style.viewTransitionName = '';
      });
    });
  }

  function init() {
    observeBubble();
    initDrawerStagger();
    initStickyAtc();
    initCounters();
    initSharedCards();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
